import { createSelector } from 'reselect';
export const getGates = state => state.video.gates;
export const getAppError = state => state.video.appError;
export const getVideo = state => state.video.video;
export const getVideoFetchError = state => state.video.videoFetchError;
export const getConfirmedVisible = state => state.video.confirmedVisible;
export const getParams = state => state.params;
export const getPlayerType = createSelector([getParams], params => params.playerType);
export const getCaptions = state => state.captions.captions;